export const subscribeToWeeklyReport = `
  mutation SubscribeToWeeklyReport($input: SubscribeToWeeklyReportInput!) {
    subscribeToWeeklyReport(input: $input) {
      success
      alreadySubscribed
      message
    }
  }
`;
